import "./App.css";
import ApiServiceManager from "./components/serviceManager";
import { ApolloProvider } from "@apollo/client";
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { SchemaProvider } from "./context/SchemaContext";

const client = new ApolloClient({
  uri: "http://localhost:5000/graphql",
  cache: new InMemoryCache(),
});

function App() {
  return (
    <ApolloProvider client={client}>
      <SchemaProvider>
        <div className="App">
          <ApiServiceManager />
        </div>
      </SchemaProvider>
    </ApolloProvider>
  );
}

export default App;
